exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".defaults[data-v-50ace45e] {\n  margin: 1em 0 2em;\n}\n.done-section[data-v-50ace45e] {\n  margin-top: 2em;\n  text-align: center;\n}\n", ""]);

// exports
